const currentDate: Date = new Date();
const currentDay: number = currentDate.getDay();

const addDays = (date: Date, numberOfDays: number): Date => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + numberOfDays);
};

const isAnOffsetDay = (date: Date, offset: number): boolean => {
  const offsetDay = addDays(currentDate, offset);

  return date.getDate() === offsetDay.getDate() && date.getMonth() === offsetDay.getMonth() && date.getFullYear() === offsetDay.getFullYear();
};

const dateIsInWeek = (date: Date): boolean => {
  const beginningOfTheWeek = addDays(currentDate, -currentDay);
  const endOfTheWeek = addDays(currentDate, 7 - currentDay);

  return beginningOfTheWeek <= date && date <= endOfTheWeek;
};

const dateIsInYear = (date: Date): boolean => {
  const beginningOfTheYear = new Date(currentDate.getFullYear(), 0);
  const endOfTheYear = new Date(currentDate.getFullYear(), 11, 31);

  return beginningOfTheYear <= date && date <= endOfTheYear;
};

/**
 * Format DateTime into user friendly date format
 * @param {Date} date: A Date object that represents a certain date
 * @returns {String}: Formatted date
 */
export const formatDateToFriendly = (date: Date): string => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  switch (true) {
    case isAnOffsetDay(date, 0):
      return 'Today';

    case isAnOffsetDay(date, -1):
      return 'Yesterday';

    case isAnOffsetDay(date, 1):
      return 'Tomorrow';

    case dateIsInWeek(date) && date < currentDate:
      return `Last ${days[date.getDay()]}`;

    case dateIsInWeek(date):
      return days[date.getDay()];

    case !dateIsInWeek(date) && dateIsInYear(date):
      return `${months[date.getMonth()]} ${date.getDate()}`;

    default:
      return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
  }
};

export default formatDateToFriendly;
